import { memoize } from 'lodash';
import { DevicePicker } from 'device-picker';
import { store } from 'Shared/react-initialize';
import { PopupActions } from 'Shared/PopupModal';
import API_2_0 from 'Shared/api_2_0';

const DEVICE_PICKER = 'device_picker_service';

const fetchHierarchy = () => {
   return new API_2_0('wikis/CATEGORY?display=hierarchy&langid=' + App.lang, {
      method: 'get',
   }).send();
};

const fetchChildren = memoize(title => {
   return new API_2_0(`wikis/CATEGORY/${title}/children?langid=${App.lang}`, {
      method: 'get',
   }).send();
});

const pushPopup = popup => {
   store.dispatch(PopupActions.pushPopup(popup));
};

const popPopup = () => {
   store.dispatch(PopupActions.popPopup());
};

const DevicePickerService = {
   fetchDevice: title => {
      const encodedTitle = DevicePickerService.encodeDeviceTitle(title);

      return new API_2_0(`wikis/CATEGORY/${encodedTitle}?langid=${App.lang}`, {
         method: 'GET',
      }).send();
   },

   encodeDeviceTitle: title => encodeURIComponent(title),

   selectDevice: props => {
      return new Promise(resolve => {
         pushPopup({
            dedup: DEVICE_PICKER,
            component: DevicePicker,
            hideClose: true,
            // These props are for the component within the Popup Modal
            props: {
               height: '85vh',
               width: '85vw',
               algoliaConfig: App.algoliaConfig && {
                  apiKey: App.algoliaConfig['apiKey'],
                  appId: App.algoliaConfig['appId'],
                  indexPrefix: App.algoliaConfig['indexPrefix'],
               },
               fetchHierarchy,
               fetchChildren,
               allowOrphan: true,
               onSubmit: value => {
                  resolve(value);
                  popPopup();
               },
               onCancel: popPopup,
               objectName: App.objectNameSingular && App.objectNameSingular.toLowerCase(),
               ...props,
            },
         });
      });
   },
};

export default DevicePickerService;
